const NO_DATA_COMPONENT_MESSAGE = {
  MAKE_SELECTION: 'Please make a selection',
  NO_DATA: 'No Data Found',
  GENERIC_ERROR:
    'We had a problem fetching the data and will look into it. Please try again later or contact support if this persists.',
};

export default NO_DATA_COMPONENT_MESSAGE;
